import React, {useState, useMemo} from "react"
import {makeStyles} from "@material-ui/core/styles"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import Input from "@material-ui/core/Input"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import {grey} from "@material-ui/core/colors"
import {useStore, useDispatch} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"

export default function PasswordForm({group = null}) {
  const {t} = useTranslation()
  const {
    store: {themeColor = `dark`},
  } = useStore()
  const {dispatch} = useDispatch()
  const [values, setValues] = useState({
    amount: ``,
    password: ``,
    weight: ``,
    weightRange: ``,
    showPassword: false,
  })

  const changePassword = (prop) => (event) => {
    const password = event.target.value
    dispatch({
      type: `PASSWORD`,
      password,
    })
    setValues({
      ...values,
      [prop]: password,
    })
  }
  const handleClickShowPassword = () =>
    setValues({
      ...values,
      showPassword: !values.showPassword,
    })
  const handleMouseDownPassword = (event) => event.preventDefault()

  const useStyles = makeStyles({
    root: {
      display: `flex`,
      flexDirection: `column`,
      textAlign: `center`,
      marginTop: 10,
    },
    label: {
      color: themeColor === `dark` ? `${grey[50]} !important` : `${grey[900]} !important`,
    },
  })
  const classes = useStyles()

  const passwordForm = useMemo(
    () => (
      <FormControl className={classes.root}>
        <InputLabel className={classes.label} htmlFor={`csv-upload-pw-${group}`}>
          {t(`password`)}
        </InputLabel>
        <Input
          id={`csv-upload-pd-${group}`}
          type={values.showPassword ? `text` : `password`}
          value={values.password}
          onChange={changePassword(`password`)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {values.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    ),
    [group, classes],
  )

  return passwordForm
}
